import * as React from 'react'
import { StackChildren } from '@doordash/design-language'
import Button from '@doordash/component-button'

import { OsTypes } from '../../../webview/types'
import { detectWebviewOs } from '../../../utilities/userAgent'
import {
  IOS,
  ANDROID,
  DASH_NOW_IOS,
  DASH_NOW_ANDROID,
  SCHEDULE_IOS,
  SCHEDULE_ANDROID,
} from './constants'
import t from './strings'
import * as DA from '../../../typeModules/events'

type FirstDashButtonProps = {
  isSubmarketBusy: boolean
  hasDashNowBenefit: boolean
  submarketId?: number
  track: (
    name: DA.EventActions,
    page: DA.ActivatedNoFirstDashScreens,
    data?: object
  ) => Promise<void>
}

export const FirstDashButtons: React.FC<FirstDashButtonProps> = ({
  isSubmarketBusy,
  hasDashNowBenefit,
  submarketId,
  track,
}) => {
  const os = detectWebviewOs()
  const prefix = os === OsTypes.iOS ? IOS : ANDROID
  const onDeepLink = deeplink => window.location.assign(`${prefix}${deeplink}`)
  // ios loads the heatmap before dash now button so android needs to know which submarket and its status
  const dashNow =
    os === OsTypes.iOS
      ? DASH_NOW_IOS
      : `${DASH_NOW_ANDROID}?startingPointId=${submarketId}&startingPointBusyness=${
          isSubmarketBusy ? 'busy' : 'not_busy'
        }`

  const schedule = os === OsTypes.iOS ? SCHEDULE_IOS : SCHEDULE_ANDROID

  const handleOnDashNow = buttonPosition => {
    track(DA.EventActions.Clicked, DA.ActivatedNoFirstDashScreens.Dash, {
      name: 'dash',
      buttonPosition,
      isSubmarketBusy,
      hasDashNowBenefit,
    })
    onDeepLink(dashNow)
  }
  const handleOnSchedule = buttonPosition => {
    track(DA.EventActions.Clicked, DA.ActivatedNoFirstDashScreens.Dash, {
      name: 'schedule',
      buttonPosition,
      isSubmarketBusy,
      hasDashNowBenefit,
    })
    onDeepLink(schedule)
  }

  if (isSubmarketBusy) {
    return (
      <StackChildren size={StackChildren.Sizes.XxSmall}>
        <Button
          size={Button.Sizes.Large}
          onClick={() => handleOnDashNow('primary')}
        >
          {t.dashNowLabel()}
        </Button>
        <Button
          size={Button.Sizes.Large}
          type={Button.Types.Tertiary}
          onClick={() => handleOnSchedule('secondary')}
        >
          {t.scheduleLaterLabel()}
        </Button>
      </StackChildren>
    )
  } else if (hasDashNowBenefit) {
    return (
      <StackChildren size={StackChildren.Sizes.XxSmall}>
        <Button
          size={Button.Sizes.Large}
          onClick={() => handleOnSchedule('primary')}
        >
          {t.scheduleLaterLabel()}
        </Button>
        <Button
          size={Button.Sizes.Large}
          type={Button.Types.Tertiary}
          onClick={() => handleOnDashNow('secondary')}
        >
          {t.dashNowLabel()}
        </Button>
      </StackChildren>
    )
  }
  return (
    <Button
      size={Button.Sizes.Large}
      type={Button.Types.Primary}
      onClick={() => handleOnSchedule('primary')}
    >
      {t.scheduleLaterLabel()}
    </Button>
  )
}
